import { Navigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { userSelector } from "../features/authSlice";
import { Spin } from "antd";
import { AUTH_TOKEN_KEY } from "../constants";

const PortalRoute = ({ children }) => {
  const { id, isSuccess, isInitialized } = useSelector(userSelector);
  const token = localStorage.getItem(AUTH_TOKEN_KEY);

  // Spinner solo en carga inicial: hay token pero aún no se restauró la sesión
  if (token && !isInitialized && !isSuccess) {
    return (
      <div style={{ minHeight: "100vh", display: "flex", justifyContent: "center", alignItems: "center" }}>
        <Spin size="large" />
      </div>
    );
  }

  if (!id || !isSuccess) {
    return <Navigate to="/portal/login" replace />;
  }

  return children;
};

export default PortalRoute;
